import moment from 'moment';
import { PERFORMANCE_ENUM } from '../enums/performance-enum';
import { performanceStatus } from '../pages/Tracking/utils/delivery-status';
import { luftGet, luftPost } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// region maps
const performanceStatusKeys = {
  [performanceStatus.ONTIME]: 'onTime',
  [performanceStatus.LATE_RISK]: 'lateRisk',
  [performanceStatus.LATE]: 'late',
};

export const PERFORMANCE_ENUM_TRANSKEY = {
  [PERFORMANCE_ENUM.NOT_INFORMED]: 'notInformed',

  [PERFORMANCE_ENUM.ON_TIME]: 'onTime',
  [PERFORMANCE_ENUM.LATE_RISK]: 'lateRisk',
  [PERFORMANCE_ENUM.LATED]: 'late',

  [PERFORMANCE_ENUM.ON_TIME_WITH_JUSTIFICATION]: 'onTimeWithJustification',
  [PERFORMANCE_ENUM.LATE_RISK_WITH_JUSTIFICATION]: 'lateRiskWithJustification',
  [PERFORMANCE_ENUM.LATED_WITH_JUSTIFICATION]: 'latedWithJustification',
  [PERFORMANCE_ENUM.LATE_WITHOUT_JUSTIFICATION]: 'lateWithoutJustification',

  [PERFORMANCE_ENUM.CANCELED]: 'Canceled',
};

// endregion

// region ACTIONS
// ACTIONS
const GET_NF_LIST_LOCATION = 'luft/dashboard-real-time/GET_NF_LIST_LOCATION';
const GET_NF_LIST_LOCATION_SUCCESS_REALTIME =
  'luft/dashboard-real-time/GET_NF_LIST_LOCATION_SUCCESS_REALTIME';
const GET_NF_LIST_LOCATION_SUCCESS_TRACKING =
  'luft/dashboard-real-time/GET_NF_LIST_LOCATION_SUCCESS_TRACKING';
const GET_NF_LIST_LOCATION_FAILURE =
  'luft/dashboard-real-time/GET_NF_LIST_LOCATION_FAILURE';

const GET_NF_DETAILS = 'luft/dashboard-real-time/GET_NF_DETAILS';
const GET_NF_DETAILS_SUCCESS =
  'luft/dashboard-real-time/GET_NF_DETAILS_SUCCESS';
const GET_NF_DETAILS_FAILURE =
  'luft/dashboard-real-time/GET_NF_DETAILS_FAILURE';

  export const MAP_EXHIBITION_TYPE = {
    TRACKER_LOCATION: 2,
    APP_LOCATION: 1,
  };


// endregion

// region initialState
const initialState = {
  activeNf: {
    isFetching: false,
    requested: '',
    received: '',
    error: '',
    data: {},
  },
  onTime: {
    isFetching: false,
    requested: '',
    received: '',
    error: '',
    data: [],
  },
  lateRisk: {
    isFetching: false,
    requested: '',
    received: '',
    error: '',
    data: [],
  },
  late: {
    isFetching: false,
    requested: '',
    received: '',
    error: '',
    data: [],
  },
  onTimeWithJustification: {
    isFetching: false,
    requested: '',
    received: '',
    error: '',
    data: [],
  },
  lateRiskWithJustification: {
    isFetching: false,
    requested: '',
    received: '',
    error: '',
    data: [],
  },
  latedWithJustification: {
    isFetching: false,
    requested: '',
    received: '',
    error: '',
    data: [],
  },
  lateWithoutJustification: {
    isFetching: false,
    requested: '',
    received: '',
    error: '',
    data: [],
  },
};
// endregion

// region reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    // ===============================
    // NF LIST LOCATION
    // ===============================
    case GET_NF_LIST_LOCATION: {
      if (action.performanceStatusCode.length === 0) {
        return state;
      }

      const getNfListLocationFetching = action.performanceStatusCode.reduce((acc, statusCode) => {
        return {
          ...acc,
          [PERFORMANCE_ENUM_TRANSKEY[statusCode]]: {
            ...state[PERFORMANCE_ENUM_TRANSKEY[statusCode]],
            isFetching: true,
            requested: action.requested,
            error: '',
          },
        };
      }, state);

      return getNfListLocationFetching;
    }

    // case GET_NF_LIST_LOCATION_SUCCESS: {
    //   const stateMap = action.data.map(item => ({
    //     [PERFORMANCE_ENUM_TRANSKEY[item.performance]]: {
    //       ...state[PERFORMANCE_ENUM_TRANSKEY[item.performance]],
    //       isFetching: false,
    //       received: action.received,
    //       data: item,
    //     },
    //   }));

    //   const objectState = Object.assign(...stateMap);

    //   return {
    //     ...state,
    //     ...objectState,
    //   };
    // }

    case GET_NF_LIST_LOCATION_SUCCESS_REALTIME: {
      return {
        ...state,
        [performanceStatusKeys[action.performanceStatusCode]]: {
          ...state[performanceStatusKeys[action.performanceStatusCode]],
          isFetching: false,
          received: action.received,
          data: action.data,
        },
      };
    }

    case GET_NF_LIST_LOCATION_SUCCESS_TRACKING: {
      const getNfListLocationFetching = action.performanceStatusCode.reduce((acc, statusCode) => {
        return {
          ...acc,
          [PERFORMANCE_ENUM_TRANSKEY[statusCode]]: {
            ...state[PERFORMANCE_ENUM_TRANSKEY[statusCode]],
            isFetching: false,
            received: action.received,
            data: action.data,
          },
        };
      }, state);

      return getNfListLocationFetching;
    }

    case GET_NF_LIST_LOCATION_FAILURE: {
      const getNfListLocationFetching = action.performanceStatusCode.reduce((acc, statusCode) => {
        return {
          ...acc,
          [PERFORMANCE_ENUM_TRANSKEY[statusCode]]: {
            ...state[PERFORMANCE_ENUM_TRANSKEY[statusCode]],
            isFetching: false,
            error: action.error,
          },
        };
      }, state);

      return getNfListLocationFetching;
    }

    // ===============================
    // NF DETAILS
    // ===============================
    case GET_NF_DETAILS: {
      return {
        ...state,
        activeNf: {
          ...state.activeNf,
          isFetching: true,
          requested: action.requested,
          error: '',
        },
      };
    }

    case GET_NF_DETAILS_SUCCESS: {
      return {
        ...state,
        activeNf: {
          ...state.activeNf,
          isFetching: false,
          received: action.received,
          data: action.data,
        },
      };
    }

    case GET_NF_DETAILS_FAILURE: {
      return {
        ...state,
        activeNf: {
          ...state.activeNf,
          isFetching: false,
          error: action.error,
        },
      };
    }

    default: {
      return state;
    }
  }
}
// endregion

// ===============================
// NF LIST LOCATION
// ===============================
function _getNfListLocation(performanceStatusCode, requested) {
  return {
    type: GET_NF_LIST_LOCATION,
    requested,
    performanceStatusCode,
  };
}

function _getNfListLocationSuccessRealTime(
  performanceStatusCode,
  data,
  received,
) {
  return {
    type: GET_NF_LIST_LOCATION_SUCCESS_REALTIME,
    received,
    data,
    performanceStatusCode,
  };
}

function _getNfListLocationSuccessTracking(
  performanceStatusCode,
  data,
  received,
) {
  return {
    type: GET_NF_LIST_LOCATION_SUCCESS_TRACKING,
    received,
    data,
    performanceStatusCode,
  };
}

function _getNfListLocationFailure(performanceStatusCode, error) {
  return {
    type: GET_NF_LIST_LOCATION_FAILURE,
    error,
    performanceStatusCode,
  };
}

// ===============================
// NF DETAILS
// ===============================
function _getNfDetails(requested) {
  return {
    type: GET_NF_DETAILS,
    requested,
  };
}

function _getNfDetailsSuccess(data, received) {
  return {
    type: GET_NF_DETAILS_SUCCESS,
    data,
    received,
  };
}

function _getNfDetailsFailure(error) {
  return {
    type: GET_NF_DETAILS_FAILURE,
    error,
  };
}

// endregion

// region thunks
export function getNfListLocation(performanceStatusCode, nfList, callback) {
  return function (dispatch) {
    const requested = moment().format();
    dispatch(_getNfListLocation(performanceStatusCode, requested));

    (async () => {
      try {
        const nfIds = nfList.map(nfObj => nfObj.id);

        const response = await luftPost(
          `/Ontime/GetGeolocation`,
          {
            invoiceIdList: nfIds
          },
          false,
          true,
        );


        const newResponse = response.data.map(item => {
          let withPerformance = {};
          // -disable-next-line array-callback-return
          nfList.find(nf => {
            if (nf.id === item.invoiceId) {
              let appLocation = null;
              let trackerLocation = null;

              if(item.geolocationDetail?.dataSource?.devices?.find(device => device.device === MAP_EXHIBITION_TYPE.APP_LOCATION)) {
                const {geolocation, detail} = item.geolocationDetail.dataSource.devices.find(device => device.device === MAP_EXHIBITION_TYPE.APP_LOCATION);

                appLocation = {
                  latitude: geolocation.latitude,
                  longitude: geolocation.longitude,
                  time: detail.time,
                  landmark: detail.landmark,
                }
              }

              if(item.geolocationDetail?.dataSource?.devices?.find(device => device.device === MAP_EXHIBITION_TYPE.TRACKER_LOCATION)) {
                const {geolocation, detail, vehicleDetail} = item.geolocationDetail.dataSource.devices.find(device => device.device === MAP_EXHIBITION_TYPE.TRACKER_LOCATION);

                trackerLocation = {
                  latitude: geolocation.latitude,
                  longitude: geolocation.longitude,
                  time: detail.time,
                  landmark: detail.landmark,
                  vehicleDetail
                };
              }

              withPerformance = {
                ...item,
                nfId: item.invoiceId,
                appLocation,
                trackerLocation,
                performance: nf.performance,
              };
            }
          });

          return withPerformance;
        });

        const received = moment().format();

        dispatch(
          _getNfListLocationSuccessRealTime(
            performanceStatusCode,
            response.data,
            received,
          ),
        );

        dispatch(
          _getNfListLocationSuccessTracking(
            performanceStatusCode,
            newResponse,
            received,
          ),
        );

        if (callback) {
          callback();
        }
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getNfListLocationFailure(performanceStatusCode, error.message),
        );
      }
    })();
  };
}

export function getNfDetails(invoiceId) {
  return function (dispatch) {
    const requested = moment().format();
    dispatch(_getNfDetails(requested));

    (async () => {
      const params = {
        invoiceId,
      };

      try {
        const response = await luftGet(
          '/IntegratedTracking/GetTrackingDeliveryDetail',
          params,
          true,
        );
        const received = moment().format();
        dispatch(_getNfDetailsSuccess(response.data, received));
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getNfDetailsFailure(error.message),
        );
      }
    })();
  };
}
// endregion
